import { disabledSettings, type MarketSettings } from './types'

export type ResolvedMarketSettings = {
  [K in keyof MarketSettings]-?: Required<NonNullable<MarketSettings[K]>>
}

/** Older public configs omit the newer controls. */
export function withDefaults(settings?: Partial<MarketSettings> | null): ResolvedMarketSettings {
  return {
    line_history: { ...disabledSettings.line_history, ...settings?.line_history },
    action_split: { ...disabledSettings.action_split, ...settings?.action_split },
    feed_cards: { ...disabledSettings.feed_cards, ...settings?.feed_cards },
    player_form: { ...disabledSettings.player_form, ...settings?.player_form },
    display: { ...disabledSettings.display, ...settings?.display },
    labels: { ...disabledSettings.labels, ...settings?.labels },
    design: { ...disabledSettings.design, ...settings?.design },
  } as ResolvedMarketSettings
}

/** Custom side colours as host custom properties; the theme sets none. */
export function sideColorProperties(
  design: ResolvedMarketSettings['design'],
): Record<string, string> {
  return design.colors === 'custom' && design.side_colors.length === 3
    ? Object.fromEntries(design.side_colors.map((color, i) => [`--market-side-${i}`, color]))
    : {}
}
